import { isFunction as _isFunction } from 'lodash'
import axios from 'axios'
import { retrieveUtilities } from '@vfgroup-oneplatform/foundation/Utils/ServicesUtils/Utilities'

import { API_URLS } from './Config'

const GetCustomerPlan = async (
  msisdn,
  customHeaders = {},
  utilities = {},
) => {
  const _utilities = retrieveUtilities(utilities)

  const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

  const data = {
    data: null,
    headers: customHeaders
  }

  onStart()

  try {
    const response = await axios.get(API_URLS.customerAccount + msisdn, data)

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)

    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

const GetProducts = async (
  msisdn,
  customHeaders = {},
  utilities = {},
) => {
  const _utilities = retrieveUtilities(utilities)

  const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

  const data = {
    params: {
      relatedPartyId: msisdn,
    },
    data: null,
    headers: customHeaders
  }

  onStart()

  try {
    const response = await axios.get(API_URLS.getProducts, data)

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)

    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

const OrderBonus = async (
  msisdn,
  name,
  coordinates,
  city,
  customHeaders = {},
  utilities = {},
) => {
  const _utilities = retrieveUtilities(utilities)

  const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

  const body = {
    '@type': 'giga_guarantee',
    'productOrderItem': [
      {
        'id': '1',
        'action': 'add',
        'product': {
          'isBundle': false,
          'place': [
            {
              '@referredType': '@referredType',
              'role': 'location',
              '@baseType': coordinates,
              '@type': 'location',
              'name': city,
              'id': 'id',
              'href': 'href',
              '@schemaLocation': 'http://example.com/aeiou',
            },
          ],
        },
      },
    ],
    'relatedParty': [
      {
        '@referredType': '@referredType',
        'role': 'subscriber',
        '@baseType': '@baseType',
        '@type': '@type',
        'name': name,
        'id': msisdn,
        'href': 'href',
        '@schemaLocation': 'http://example.com/aeiou',
      },
    ],
  }

  onStart()

  try {
    const response = await axios.post(API_URLS.gigaBonus, body, { headers: customHeaders })

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)

    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

export { GetCustomerPlan, GetProducts, OrderBonus }
